import { Button, Checkbox, Form } from "antd";
import React, { useCallback } from 'react';
import { callEventPopup, openPopup2 } from "../../../../contexts/PopupContext";

const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
};

const style = { marginBottom: 0, display: 'inline-block', width: '100%' }
const styleItem = { marginBottom: '5px', lineHeight: '36px' };

interface IProps {
    onOk(params: any): void
}

const PopupAutoRoute: React.FC<IProps> = (props) => {
    const { onOk } = props;
    const { onClose } = callEventPopup();

    const handleOk = useCallback((values: any) => {
        onOk(values);
        onClose();
    }, [onClose, onOk]);

    return <Form {...layout}
        onFinish={handleOk}
        initialValues={{
            mode: 'Exact',
            safe_depth: 10,
            airDraft: 10
        }}
    >
        <Form.Item style={styleItem}>
            <Form.Item {...{ style, name: 'avoid_disease' }} valuePropName="checked">
                <Checkbox>Avoid disease</Checkbox>
            </Form.Item>
        </Form.Item>
        <div className='flex justify-end'>
            <Button className='bt-primary mt-10' htmlType="submit">Generate</Button>
        </div>
    </Form>;
}

interface IOpenAutoRoute {
    onOk(params: { avoid_disease: boolean }): void
}

export const openAutoRoute = (props: IOpenAutoRoute) => {
    openPopup2(<PopupAutoRoute onOk={props.onOk} />, {
        modalProps: {
            title: 'Auto route',
            width: 400,
        }
    });
}

export default PopupAutoRoute;
